<template>
  <div class="shenyunjie-chart-dome-settlement" :id="id"></div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-gl";
import merge from "deepmerge";

export default {
  name: "YunJieChartDomeSettlement",
  props: {
    id: {
      type: String,
      default: function () {
        return new Date().getTime() + "-" + Math.ceil(Math.random() * 1000);
      }
    },
    loadChart: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: Array,
      default: function () {
        return [];
      }
    },
    x: {
      type: String,
      default: ""
    },
    y: {
      type: String,
      default: ""
    },
    z: {
      type: String,
      default: ""
    },
    unit: {
      type: String,
      default: ""
    },
    sType: {
      type: String,
      default: "plane"
    },
    timeType: {
      type: String,
      default: "realtime"
    },
    tooltip: {
      type: Boolean,
      default: true
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    updateOption: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      chart: null,
      resizeObserver: null
    };
  },
  mounted() {
    let self = this;
    // 窗口大小变化监听
    window.addEventListener("resize", self.resizeDomeSettlement);
    // 元素大小变化监听
    self.resizeObserver = new ResizeObserver((entries) => {
      if (self.chart) {
        self.chart.dispose();
        this.chart = null;
      }
      self.init();
    });
    self.resizeObserver.observe(document.getElementById(self.id));
    if (self.loadChart) {
      self.init();
    }
  },
  methods: {
    resizeDomeSettlement() {
      let self = this;
      if (self.chart) {
        self.chart.resize();
      }
    },
    init() {
      let self = this;
      // 页面已存在
      if (document.getElementById(self.id) && document.getElementById(self.id).offsetHeight > 0) {
        // 初始化
        let theme = self.theme || (this.$YunJie || {}).theme || "standard";
        if (!self.chart) {
          if (theme == "darkness") {
            self.chart = echarts.init(document.getElementById(self.id), "dark");
          } else {
            self.chart = echarts.init(document.getElementById(self.id));
          }
        }
        // 配置汇总
        let opt = self.sType == "plane" ? self.getPlane(theme) : self.get3D(theme);
        // 合并自定义配置
        opt = merge(opt, self.option);
        // 用户自定义属性
        if (self.updateOption) {
          opt = self.updateOption(opt);
        }
        self.chart.setOption(opt, true);
        self.chart.resize();
      }
    },
    getPlane(theme) {
      let self = this;
      let series = [];
      if (self.timeType == "history") {
        series = self.value.map(x => { return { name: x.time, type: "line", data: x.data, smooth: true } });
      } else {
        series = [{
          type: "line",
          data: self.value,
          smooth: true
        }]
      }
      // 配置汇总
      let parameter = {
        grid: {
          top: self.timeType == "history" ? 52 : 32,
          bottom: 28,
          left: 56,
          right: 20
        },
        title: {
          left: "center",
          text: self.title
        },
        yAxis: {
          type: "value",
          scale: true
        },
        xAxis: {
          type: "value",
          scale: true
        },
        tooltip: {
          show: self.tooltip,
          trigger: "axis",
          formatter: function (params) {
            let str = "";
            if (params.length == 1) {
              str += `${self.x || "x"}：${params[0].data[0]}${self.unit}<br>`;
              str += `${self.y || "y"}：${params[0].data[1]}${self.unit}`;
            } else {
              params.forEach((item, idx) => {
                str += `${item.marker} ${item.seriesName}: `;
                str += `${self.x || "x"}：${item.data[0]}${self.unit}，`;
                str += `${self.y || "y"}：${item.data[1]}${self.unit}`;
                str += idx === params.length - 1 ? "" : "<br/>";
              });
            }
            return str;
          }
        },
        legend: {
          show: self.timeType == "history",
          type: "scroll",
          top: 24,
          itemStyle: {
            opacity: 0
          },
          pageIconColor: theme == "darkness" ? "#ffffff" : "#2f4554",
          pageTextStyle: {
            color: theme == "darkness" ? "#B9B8CE" : "#333333"
          }
        },
        series: series
      };
      return parameter;
    },
    get3D(theme) {
      let self = this;
      // 配置汇总
      let parameter = {
        title: {
          left: "center",
          text: self.title
        },
        grid3D: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          viewControl: {
            alpha: 6,
            panMouseButton: "right"
          },
          axisLabel: {
            textStyle: {
              color: theme == "darkness" ? "#cccccc" : "#333333"
            }
          },
          axisLine: {
            lineStyle: {
              color: theme == "darkness" ? "#cccccc" : "#333333"
            }
          }
        },
        tooltip: {
          show: self.tooltip,
          formatter: function (params) {
            let str = "";
            str += `监测点：${params.name}<br/>`;
            str += `${self.x || "x"}：${params.data.value[0]}${self.unit}<br/>`;
            str += `${self.y || "y"}：${params.data.value[1]}${self.unit}<br/>`;
            str += `${self.z || "z"}：${params.data.value[2]}${self.unit}`;
            return str;
          }
        },
        xAxis3D: {
          type: "value",
          name: self.x || "X",
          scale: true
        },
        yAxis3D: {
          type: "value",
          name: self.y || "Y",
          scale: true
        },
        zAxis3D: {
          type: "value",
          name: self.z || "Z",
          scale: true
        },
        series: [{
          type: "surface",
          data: self.value
        }]
      };
      return parameter;
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeDomeSettlement);
    this.resizeObserver.disconnect();
  },
  watch: {
    theme() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.init();
    },
    title() {
      this.init();
    },
    value: {
      deep: true,
      handler(xData) {
        this.init();
      }
    },
    x() {
      this.init();
    },
    y() {
      this.init();
    },
    z() {
      this.init();
    },
    unit() {
      this.init();
    },
    sType() {
      this.init();
    },
    timeType() {
      this.init();
    },
    tooltip() {
      this.init();
    },
    option: {
      deep: true,
      handler(option) {
        this.init();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shenyunjie-chart-dome-settlement {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/domeSettlement.vue